import { Flex, FlexProps, Text, TextProps } from "@chakra-ui/react";
import React from "react";

export function SectionTitle({ ...props }: TextProps): React.ReactElement {
  return <Text fontWeight="semibold" fontSize="lg" {...props} />;
}

export function SectionContainer({ ...props }: FlexProps): React.ReactElement {
  return (
    <Flex
      justifyContent="flex-start"
      align="center"
      gap={1}
      mb={4}
      px={TransactionOverviewPaddingX}
      {...props}
    />
  );
}

export const TransactionOverviewPaddingX = {
  base: 4,
  md: 6,
};
